export function worksArea() {
    const $window = $(window);
    let $windowWidth = $window.width();
    const $windowHeight = $window.height();
    const worksArea = $(".works-area");

    worksArea.each(function () {
        const $this = $(this);
        const itemsNav = $this.find(".works-area-nav");
        const itemsList = $this.find(".works-area-list");
        const itemsListItems = itemsList.find(".item");
        const image = $(".works-area-image img");
        image.addClass('active');
        itemsListItems.eq(0).addClass('active');

        $window.on("load resize", function () {
            if ($window.innerWidth() > 1023) {
                if (itemsList.hasClass("slick-initialized")) {
                    itemsList.slick('refresh');
                    itemsList.slick('unslick');
                    itemsNav.slick('refresh');
                    itemsNav.slick('unslick');
                }
            } else {
                if (!itemsList.hasClass("slick-initialized")) {
                    itemsList.slick({
                        slidesToScroll: 1,
                        slidesToShow: 1,
                        asNavFor: itemsNav,
                        infinite: false,
                        arrows: false,
                        fade: true,
                        adaptiveHeight: true
                    });
                    itemsNav.slick({
                        slidesToShow: 1,
                        slidesToScroll: 1,
                        asNavFor: itemsList,
                        infinite: false,
                        dots: false,
                        arrows: false,
                        focusOnSelect: true,
                        variableWidth: true
                    })
                }
            }
        });

        $window.on("scroll load", function () {
            if ($windowWidth > 1023) {
                let scrollTop = $(document).scrollTop();
                itemsListItems.each(function () {
                    const $this = $(this);
                    const itemOffsetTop = $this.offset().top;
                    const itemHeight = $this.outerHeight(true);
                    const imageSrc = $this.find('img').attr('src');

                    if ((scrollTop + $windowHeight / 3 >= itemOffsetTop) && (scrollTop + $windowHeight / 3 <= itemOffsetTop + itemHeight)) {
                        if (!$this.hasClass('active')) {
                            $this.siblings().removeClass('active');
                            $this.addClass('active');
                            image.removeClass('active');
                            setTimeout(() => {
                                if (imageSrc) {
                                    image.attr("src", imageSrc);
                                    image.addClass('active');
                                }
                            }, 400);
                        }
                    } else {
                        // $this.removeClass('active');
                    }
                });
            }
        });
    });

    $window.on('resize', function () {
        $windowWidth = $window.width();
    });
}


// WEBPACK FOOTER //
// ./assets/js/modules/worksArea.js